module.exports = __webpack_public_path__ + "img/banner1.9b31fe08.png";